import { render, staticRenderFns } from "./UpdatesList.vue?vue&type=template&id=1fcb430c"
import script from "./UpdatesList.vue?vue&type=script&lang=js"
export * from "./UpdatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports